import React from 'react';
import type { ResponseStatus } from '../../types';
import type { CampaignDisplayStatus } from '../../lib/admin-utils';
import { sessionStatusColors, sessionStatusLabels, responseStatusConfig } from '../../lib/admin-utils';

interface SessionStatusBadgeProps {
  /** The campaign display status to show. */
  status: CampaignDisplayStatus;
}

interface ResponseStatusBadgeProps {
  /** The response status to display. */
  status: ResponseStatus;
}

type StatusBadgeProps =
  | ({ type: 'session' } & SessionStatusBadgeProps)
  | ({ type: 'response' } & ResponseStatusBadgeProps);

/**
 * Status badge with consistent styling for session and response statuses.
 * Renders a pill-shaped span with the appropriate color and label.
 */
export const StatusBadge: React.FC<StatusBadgeProps> = (props) => {
  let className: string;
  let label: string;

  if (props.type === 'session') {
    className = sessionStatusColors[props.status];
    label = sessionStatusLabels[props.status];
  } else {
    const config = responseStatusConfig[props.status];
    className = config.className;
    label = config.label;
  }

  return (
    <span className={`inline-block whitespace-nowrap px-2 py-1 rounded-full text-sm font-medium ${className}`}>
      {label}
    </span>
  );
};
